export default{
  serveIndex:{
    navList:["保真保质服务","金融及保险服务","海关服务","物流服务","法律服务","外贸服务","人才及培训服务"]
  }
  
}